import React from 'react'
import styles from './FullPageOverlay.module.css'

type FullPageOverlayProps = {
    isVisible: boolean
    onDismiss: () => void
}

export const FullPageOverlay = ({ isVisible, onDismiss }: FullPageOverlayProps) => {
    if (!isVisible) return null

    return (
        <div
            className={styles.overlay}
            onClick={onDismiss}
            aria-hidden="true"
        />
    )
}
